<template>
    <div class="container">
        <b-modal
            :model-value="modalCrear"
            :no-close-on-backdrop="true"
            hide-footer
            hide-header-close
            centered
            :title="labels.title"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog"
        >
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-3">
                    <div class="password-policy-title">
                        {{ labels.formInfoTitle }}
                    </div>
                    <div class="password-policy-item">
                        {{ labels.formInfoSubtitle }}
                    </div>
                </div>
                <b-col md="4" lg="12" class="p-0 mx-auto">
                    <b-form-group>
                        <label>{{ labels.codigo }}</label>
                        <b-form-input
                            v-model="form.codigo"
                            type="number"
                            class="reset-input"
                        ></b-form-input>
                        <label>{{ labels.descripcion }}</label>
                        <b-form-input
                            v-model="form.descripcion"
                            type="text"
                            class="reset-input"
                        ></b-form-input>
                    </b-form-group>
                    <div class="reset-dialog-actions d-flex justify-content-end mt-3 uniform-actions-wrap">
                        <b-button
                            class="mr-2 reset-btn-secondary"
                            @click="cierraModal()"
                        >
                            {{ labels.close }}
                        </b-button>
                        <b-button
                            class="reset-btn-primary"
                            @click="guardarTipoTercero()"
                        >
                            {{ labels.save }}
                        </b-button>
                    </div>
                </b-col>
            </div>
        </b-modal>
    </div>
</template>

<script>
import TipoTercero from '../../../services/TipoTerceros' 
export default {
    name:'Crear',
    props:{
        modalCrear: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            form: {
                codigo: "",
                descripcion: ""
            }
        }
    },
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") { 
                return {
                    title: "Crear tipo tercero",
                    codigo : "Código",
                    descripcion : "Descripción",
                    save : "Guardar",
                    close : "Cerrar",
                    formInfoTitle: "Datos del tipo de tercero",
                    formInfoSubtitle: "Completa la información y guarda el nuevo tipo de tercero."
                }
            }else{
                return {
                    title: "Create tipo tercero",
                    codigo : "Code",
                    descripcion : "Description",
                    save : "Sava",
                    close : "Close",
                    formInfoTitle: "Third type data",
                    formInfoSubtitle: "Complete the information and save the new third type."
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.cleanInp();
            this.$emit('cierraModal',false) 
        },
        guardarTipoTercero() {

            if (!this.form.codigo || !this.form.descripcion.trim()) {
                this.$toast.error("Campo(s) pendiente(s) por diligenciar");
                return;
            }

            const info = {
                codigo: this.form.codigo,
                descripcion: this.form.descripcion,
                idUser: this.$store.state.userId
            };

            TipoTercero.createTipoTercero(info)
            .then((res) => {

                if (res.status === 200) {

                    this.$toast.success(res.data.message);
                    this.$emit("creado", res.data.tipoTercero);
                    this.cierraModal();

                } else if (res.status === 204) {

                    this.$toast.error("Tipo tercero ya existe.");
                }

            })
            .catch((error) => {
                console.error(error);
                this.$toast.error("Ocurrió un error al guardar.");
            });
        },
        cleanInp(){
            this.form.codigo = "";
            this.form.descripcion = "";
        }
    }
}
</script>

<style>

</style>
